import { Button, Modal } from "antd";
import { BellOutlined, ArrowUpOutlined } from "@ant-design/icons";
import ModalTitle from "../ModalTitle";
import styles from "./styles.module.css";

const NotifPermissionModal = ({ isOpen, onAccept, onDecline, loading }) => (
  <Modal
    className="ds-modal"
    /* Tagged so a tour queued on the page can wait for the prompt to close
     * instead of dropping its mask over it — see useTourTrigger. */
    wrapClassName="notif-permission-modal"
    open={isOpen}
    onCancel={() => !loading && onDecline()}
    centered
    width={440}
    maskClosable={!loading}
    title={
      <ModalTitle
        icon={<BellOutlined />}
        title="اعلان‌ها رو روشن کنیم؟ 🔔"
        subtitle="تا هیچ تسکی از دستت در نره."
      />
    }
    footer={
      <div className={styles.footer}>
        <Button disabled={loading} onClick={onDecline}>
          الان نه
        </Button>
        <Button
          type="primary"
          icon={<BellOutlined />}
          loading={loading}
          onClick={onAccept}
        >
          روشن کن
        </Button>
      </div>
    }
  >
    <p className={styles.lead}>
      هر وقت تسکی بهت واگذار شد، سررسیدی نزدیک بود یا تو تیم پیامی گرفتی، همون
      لحظه خبرت می‌کنیم.
    </p>
    <div className={styles.callout}>
      <span className={styles.calloutIcon}>
        <ArrowUpOutlined />
      </span>
      <span className={styles.calloutText}>
        بعد از زدن دکمه، مرورگر هم بالای صفحه یه اجازه می‌خواد — حتماً تاییدش کن.
      </span>
    </div>
  </Modal>
);

export default NotifPermissionModal;
